import React, { useState } from 'react';

import { IconButton } from 'components';
import { ButtonV3 } from 'components/ComponentV2';
import Modal from 'components/Modal';

import { useSocietyProfile } from 'pages/society-profile/UseSocietyProfile.hook';
import { ComunityInvitesOptions } from 'lib/models/community';
import InviteConfirmationModal from '../InviteConfirmationModal';
import styles from './InviteMembersConfirmationModal.module.scss';

interface InviteMembersConfitmationModalProps {
  open: boolean;
  isSingleMember: boolean;
  onClose: () => void;
  selectedDropDown?: string;
  onDoneClick?: (doneClicked: boolean) => void;
}

export const InviteMembersConfitmationModal: React.FC<InviteMembersConfitmationModalProps> =
  (props: InviteMembersConfitmationModalProps) => {
    const { open, onClose, isSingleMember, selectedDropDown, onDoneClick } =
      props;
    const { inviteAttendees, inviteProfileViewers, inviteEventViewers } =
      useSocietyProfile();

    const [showConfirmationModal, setShowConfirmationModal] = useState(false);
    const onDone = async () => {
      onClose();
      onDoneClick && onDoneClick(true);

      if (selectedDropDown === ComunityInvitesOptions.INVITE_ALL_ATTENDEES) {
        try {
          await inviteAttendees();
          await setShowConfirmationModal(true);
        } catch (err) {
          console.error(err);
        }
      } else if (
        selectedDropDown === ComunityInvitesOptions.INVITE_ALL_EVENT_VIEWERS
      ) {
        try {
          await inviteEventViewers();
          await setShowConfirmationModal(true);
        } catch (err) {
          console.error(err);
        }
      } else if (
        selectedDropDown === ComunityInvitesOptions.INVITE_ALL_PROFILE_VIEWERS
      ) {
        try {
          await inviteProfileViewers();
          await setShowConfirmationModal(true);
        } catch (err) {
          console.error(err);
        }
        await inviteProfileViewers();
      }
    };
    return (
      <>
        <Modal
          isOpen={open}
          onRequestClose={onClose}
          closeOnOverlayClick={false}
          contentClassName={styles.AddSubscribersModal}
        >
          <div className={styles.AddSubscribersModalHeader}>
            <p>Invite members</p>
            <IconButton
              className={styles.closeIcon}
              iconName="close"
              size="small"
              onClick={onClose}
            />
          </div>

          <div className={styles.AddSubscribersModalContent}>
            <div className={styles.disclaimerBox}>
              <p className={styles.caption}>
                This will send an email invite to join your community. Are you
                sure you want to send the invite?
              </p>
            </div>
          </div>

          <div className={styles.AddSubscribersModalAction}>
            <ButtonV3 color="secondary" onClick={onClose}>
              Cancel
            </ButtonV3>
            <ButtonV3 onClick={onDone} color="primary">
              Confirm
            </ButtonV3>
          </div>
        </Modal>
        {showConfirmationModal && (
          <InviteConfirmationModal
            isOpen={showConfirmationModal}
            onClose={() => setShowConfirmationModal(false)}
            isSingleMember={isSingleMember}
          />
        )}
      </>
    );
  };
